import "./Footer.css"
import CustomModal from "../CustomModal";
import {useState} from "react";
import ContactUs from "../ContactUs/ContactUs";
import {connect} from "react-redux";

const Footer = ({
				   }) => {

	const defaultModal = {
		modalTitle: "",
		modalText: "",
		confirmText: "",
		cancelText: "",
		show: false,
		handleClose: () => {
			updateModal({show: false});
		},
		handleHide: null,
		handleConfirm: null,
		handleCancel: null
	};
	const [modal, setModal] = useState(defaultModal);
	const updateModal = (updates, reset = false) => {
		const placeholder = reset ? defaultModal : modal;
		setModal({...placeholder, ...updates});
	}

	const handleContactUs = () => {
		updateModal({
			modalTitle: "Contact Us",
			modalText: ContactUs,
			confirmText: null,
			cancelText: null,
			handleConfirm: (data) => {
				updateModal({
					modalTitle: null,
					modalText: data,
					confirmText: "Ok",
					cancelText: null,
					show: true,
					handleHide: null,
					handleConfirm: null
				});
			},
			show: true,
			style: {'--bs-modal-width': '80vw'} // TODO: gestirlo con il size (non prende la variabile?)
		});
	}

	const currentYear = new Date().getFullYear();
	const termsAndConditionsPDFlink = process.env.REACT_APP_MAPIT_TERMS_AND_CONDITIONS_PDF;
    const apiManualDownloadLink = process.env.REACT_APP_MAPIT_API_MANUALS_LINK;
	return <>
			<div className='footer--global'>
				<div className="footer">
					{/*<div className='div--icon'>*/}
					{/*	<AiOutlineTwitter size={39} color="#373737" className='footer--icon'/>*/}
					{/*	<AiFillFacebook size={39} color="#373737" className='footer--icon'/>*/}
					{/*	<AiFillYoutube size={39} color="#373737" className='footer--icon'/>*/}
					{/*</div>*/}
					<div className='div--links'>
						<a className='link' style={{cursor: "pointer"}} onClick={handleContactUs}>Contact us</a>
						{
							termsAndConditionsPDFlink ? <a className='link' target="_blank" href={termsAndConditionsPDFlink}>Terms and conditions</a> : null
						},
                        {
							apiManualDownloadLink ? <a className='link' target="_blank" href={apiManualDownloadLink}>Download API Manuals</a> : null
						}
					</div>
				</div>
				<div className="footer--small">
					<small>Copyright © {currentYear}  All rights reserved - Powered by e-GEOS - P.IVA 1032180778</small>
				</div>
			</div>
			<CustomModal {...modal} />
		</>
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
